module.exports={
    "index": {
        "login": "Kedudukan ahli",
        "regist": "Hadiah untuk pengguna baharu",
        "user": "pasukan baru",
        "jiang": "ahli",
        "set": "Teguran",
        "lingqyu": "Tiada catatan dimasukkan , sila tetapkan",
        "liji": "tidak dimasukkan , sila tetapkannya",
        "list": {
            "0": "Masa deposit",
            "1": "Maklumat kad debit",
            "2": "Nota : Dompet Bitcoin dan dompet USDT dicas semula. 10% percuma daripada prinsipal caj semula + yuran pengendalian USD 20",
            "3": "Maaf saya tidak mendapatnya , sila terus membelinya",
            "4": "dolar",
            "5": "Jumlah pesanan pada hari pertama telah mencecah 20, dan tiada lagi pesanan boleh dibuat.",
            "6": "Hantar sekarang"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "akaun bank",
                "1": "Batalkan pesanan"
            },
            "tianjia": {
                "0": "alamat",
                "1": "Tiada alamat dimasukkan , sila tetapkan"
            },
            "tiqu": {
                "0": "sila masukkan",
                "1": "Baki akaun kurang daripada 200, sila caj semula sebelum mengambil pesanan"
            }
        },
        "guanyu": {
            "title1": "Sila semak baki akaun",
            "text1": "Baki akaun yang tersedia tidak mencukupi",
            "title2": "Pesanan telah diproses , sila muat semula halaman",
            "text2": "Ralat parameter , sila sahkan nombor pesanan"
        },
        "title_content": {
            "0": "Nombor pesanan tidak wujud",
            "1": "Gagal mengambil pesanan . Inventori tidak mencukupi dalam julat harga kategori ini.",
            "2": "Rampas pesanan gagal ! Sila cuba lagi nanti"
        },
        "content": {
            "0": "Grab order berjaya",
            "1": "pesanan tidak mencukupi, sila order semula.",
            "2": "ambillah"
        },
        "dugengduo": "Baki tahap keahlian tidak mencukupi",
        "darkgrey": {
            "1": {
                "title": "Merebut pesanan telah ditamatkan",
                "text": "Masa daftar masuk"
            },
            "2": {
                "title": "dapatkan sampul merah",
                "text": "Pergi untuk mengisi semula"
            },
            "3": {
                "title": "Tengok lagi",
                "text": "Baki akaun perlu lebih daripada 200 untuk membuka kunci"
            },
            "4": {
                "title": "Langkah seterusnya",
                "text": "Kod pengesahan"
            },
            "5": {
                "title": "sila masukkan kod pengesahan",
                "text": "Pengesahan kod pengesahan grafik gagal , sila masukkan semula"
            },
            "6": {
                "title": "Permintaan berjaya",
                "text": "Format nombor telefon mudah alih tidak betul"
            }
        },
        "into": {
            "yibiaoban": "akaun tidak wujud",
            "nihao": "Pengguna tidak wujud",
            "yue": "Pengguna dilumpuhkan",
            "shebeigong": "Akaun ini sudah dilog masuk di tempat lain",
            "riqi": "Kata laluan telah dimasukkan dengan salah terlalu banyak kali berturut-turut",
            "gaishu": "Cuba lagi dalam beberapa minit",
            "kaicaizong": "Salah kata laluan",
            "xiaoshili": "log masuk dengan jayanya",
            "rili": "Kod pengesahan tidak wujud",
            "zhouli": "Ralat kod pengesahan",
            "yeli": "Kod pengesahan tidak sah",
            "tuilian": "Kod jemputan tidak wujud",
            "hezuo": "Pengguna yang disyorkan telah dinyahaktifkan",
            "fukuanxin": "Permintaan buruk",
            "tianjiadi": "Sila log masuk dahulu",
            "gengxin": "Akaun ini telah dilumpuhkan",
            "yibiaoti": "Fungsi dagangan akaun ini telah dibekukan",
            "yaoqing": "Akaun ini mempunyai pesanan yang belum selesai dan tidak boleh terus mengambil pesanan.",
            "yaoqingren": "Baki kurang daripada",
            "shijian": "Tidak dapat meneruskan dagangan",
            "choujiangci": "Bilangan transaksi yang tidak mencukupi untuk tahap keahlian",
            "choujianggai": "harta faedah",
            "tuijianren": "Pengeluaran awal sebelum tamat tempoh , tiada keuntungan, yuran pengendalian adalah",
            "xiejie": "Jumlah pelaburan minimum untuk produk ini",
            "jiriqi": "Jumlah pelaburan maksimum untuk produk ini",
            "dianjifu": "Anomali data",
            "tishi": {
                "1": "Baki yang tersedia tidak mencukupi",
                "2": "Operasi yang berjaya",
                "3": "Operasi gagal ! Sila semak baki akaun anda"
            },
            "chongzhijin": "Memulakan pelaburan",
            "chongzhigai": "beroperasi",
            "nindeyu": "Pemindahan baki faedah",
            "mianchong": "Ulang operasi",
            "mianchongci": "Memindahkan baki faedah",
            "chongzhili": {
                "title": "Ralat parameter",
                "jine": "dilarang daripada",
                "shijian": "Lakukan operasi semasa di luar tempoh masa",
                "zhauntai": "Caj semula tidak boleh kurang daripada"
            },
            "yijiangli": "Caj semula tidak boleh lebih besar daripada",
            "yiqizhuan": "Ralat format imej",
            "jianglili": "Penyerahan gagal , sila cuba lagi kemudian",
            "shezhi": "WeChat Pay",
            "mimashe": "Bayar dengan Ali-Pay",
            "dangqianmishu": "Pengeluaran tunai WeChat",
            "xinmi": "Pengeluaran tunai Alipay",
            "shuxinmi": "Tiada maklumat kad bank telah ditambahkan lagi",
            "quemi": "Tiada kata laluan transaksi ditetapkan",
            "shuquemi": "Had pengeluaran peringkat keahlian ialah",
            "dainyou": "Pengeluaran tahap semasa perlu diselesaikan",
            "dianyoudi": "pesanan",
            "shudainyou": "Baki tidak mencukupi",
            "fukuanshe": "Bilangan pengeluaran untuk peringkat ahli hari ini tidak mencukupi.",
            "bitedi": "Nama pemegang akaun diperlukan",
            "shugukuan": "Panjang maksimum nama pemegang akaun ialah 30 aksara.",
            "jisheng": "Nama bank diperlukan",
            "qiangou": "Nombor kad bank diperlukan",
            "xiacixiaoshi": "Nombor telefon bimbit diperlukan",
            "yingjian": "Nombor kad bank sudah wujud",
            "zonggong": "operasi gagal",
            "maidian": "Halaman tidak wujud",
            "yingjiancheng": "Dapatkan rebat",
            "zhuanzhang": "Pengguna tidak log masuk",
            "dianfeizong": "Tolong jangan serahkan semula",
            "zhuanzhangti": "mendapat kejayaan",
            "zhaunzhangfeiyong": "gagal",
            "zuidifei": "kejayaan",
            "tikuanjin": "Nama dan kad bank ini telah diikat ke akaun lain",
            "zuidixian": "Tidak dapat memadamkan alamat penghantaran lalai",
            "bijieshou": "Kata laluan log masuk salah",
            "quezhi": "Log masuk hari ini",
            "querenti": "Log masuk berjaya dan dapatkan sampul merah",
            "yiwen": "Log masuk berjaya",
            "tili": "Semua pesanan pengeluaran anda",
            "yaohaoyou": "Pengesahan lulus",
            "yaohuoci": "Sila log masuk untuk mendapatkan pesanan",
            "yihanwei": "Gagal merebut pesanan , sila cuba sebentar lagi",
            "gongxihuo": "Rampas pesanan gagal , inventori produk tidak mencukupi"
        },
        "taocan": {
            "title": "Nombor telefon bimbit telah didaftarkan",
            "text": "Hanya satu mesej teks boleh dihantar dalam masa 1 minit",
            "kuanggong": "Berjaya dihantar",
            "liliang": "gagal untuk dihantar",
            "jiage": "SMS berjaya dihantar",
            "yingli": "Parameter tidak lengkap"
        },
        "baoming": {
            "title": "Ruang pelayan tidak disokong . Sila sahkan bahawa ia menyokong curl atau fsocket Hubungi pembekal ruang anda untuk menyelesaikan masalah atau menukar ruang.",
            "text": "Akaun telah tamat tempoh"
        }
    },
    "login": {
        "yongdeng": "Sekatan alamat IP",
        "quedeng": "Kandungan mengandungi perkataan sensitif",
        "yonghu": "Keabnormalan parameter produk",
        "mima": "Baki yang ada tidak mencukupi , sila tambah nilai dahulu",
        "xieyi": "Jumlah hari ini",
        "tiaokaun": "Bilangan pengguna hari ini",
        "tongyi": "Bilangan orang dalam talian hari ini",
        "wangmi": "tahun",
        "zhaomi": "bulan",
        "zhaomiti": "Log masuk",
        "feihuiyuan": "berterusan",
        "lizhi": "Mendaftar masuk hari ini dan menerima 1 sampul merah",
        "chaunghu": "hari",
        "yonghumming": "satu",
        "mimafu": "dua",
        "zhanghaoyou": "Empat",
        "jinggao": "lima"
    },
    "botton": {
        "lianjie": {
            "0": "enam",
            "1": "Log masuk",
            "2": "Sudah log masuk hari ini",
            "3": "pindah keluar"
        },
        "zhichi": {
            "0": "pindah masuk",
            "1": "Mall"
        }
    },
    "content": {
        "zhichu": "satu",
        "jiage": "Kadar kedua",
        "yinliang": "Tiada kebenaran",
        "jiaoyizhe": "Sediakan mesej",
        "btbjiage": "R",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "Satu akaun boleh grab dalam 1 hari",
        "choujiang": "suruhanjaya penjanaan",
        "jiangli": "Tahap 1",
        "chongzhi": "Tiga generasi komisen",
        "zhuanzhang": "Tahap tiga",
        "yongjin": "Muat naik tangkapan skrin pembayaran",
        "lijikaishi": "Tarik ke atas untuk menyegarkan",
        "mianfei": "Saluran eksklusif peringkat seterusnya boleh mendapat komisen yang lebih tinggi",
        "kaishi": "Tarik ke bawah untuk menyusun semula",
        "lianjie": "Rebat komisen bawahan",
        "zhoumo": "Tidak boleh kosong",
        "shizhi": "Perkhidmatan pelanggan yang berdedikasi",
        "jiaoyi": "Kata laluan yang dimasukkan dua kali tidak konsisten",
        "zhichi": "Kata laluan dana yang dimasukkan dua kali adalah tidak konsisten",
        "fuzhi": "maklumat peribadi",
        "dangqian": "Untuk mengelakkan pengawasan platform, seperti pesanan yang sepadan",
        "wanshan": "Sila sahkan kata laluan transaksi",
        "buyizhi": "Mesej pembeli",
        "ziyou": "belajar",
        "mai": "Suruhanjaya generasi kedua",
        "yaoqing": "Tahap 2",
        "yihan": "kod QR",
        "gongxi": "Pengurusan kata laluan transaksi",
        "huifu": "Butiran transaksi"
    },
    "tanchuang": {
        "one": "Jumlah tempahan yang diambil hari ini",
        "two": "Dah grab komisen hari ni",
        "title1": "Keputusan hari ini",
        "title2": "Pendapatan hari ini"
    },
    "weishangxian": {
        "weishangxian": "Selepas operasi di atas selesai, sila hubungi perkhidmatan pelanggan untuk meningkatkan skor.",
        "yueshouru": "harga",
        "meiyuan": "Lebih banyak tugas",
        "qianggouzhong": "dewan misi",
        "chongzhidizhi": "Rebat tugas",
        "jine": "kupon",
        "bufu": "Keahlian sah selama-lamanya",
        "zhengque": "peringkat keahlian",
        "xuanxiang": "Butiran ahli",
        "chongzhi": "Rekod deposit dan pengeluaran Yu'e Bao",
        "xiaoshi": "Pendapatan Yu'e Bao",
        "yongjiu": "Perpindahan Yu'e Bao",
        "yongjin": "Yu'e Bao berpindah keluar",
        "renshu": "Yu'E Bao",
        "hezuo": "baki pembayaran",
        "fenxiang": "Pemindahan baki",
        "chenggong": "seimbang",
        "tuijianID": "Helo , untuk melindungi hak dan kepentingan anda, sila ikat nombor kad dan maklumat cawangan yang betul bagi empat bank utama (Bank China, Pembinaan, Industri dan Perdagangan, Pertanian Jika anda mengisi maklumat yang salah dan akaun tidak boleh). diterima, platform ini tidak akan memikul sebarang tanggungjawab! Platform ini tidak menyokong pengeluaran tunai daripada bank selain daripada empat bank utama.",
        "neirong": "Komisen tambah",
        "tuijian": "Kadar komisen"
    },
    "into_one": {
        "yibiaoban": "komisen",
        "nihao": "Simpan kod QR ke kod imbasan setempat",
        "yue": "Berjaya disimpan",
        "shebeigong": "Simpan tangkapan skrin dan imbas kod QR untuk membayar",
        "riqi": "Pengumuman maklumat",
        "gaishu": "Ubah suai nama",
        "kaicaizong": "tukar kata laluan",
        "xiaoshili": "Berjaya diubah suai",
        "rili": "Yuan",
        "zhouli": "Mengecas semula",
        "yeli": "Mengecas semula , sila muat semula baki kemudian",
        "tuilian": "Isi semula dan naik taraf",
        "hezuo": "Status cas semula",
        "fukuanxin": "Tingkatkan untuk membuka kunci",
        "tianjiadi": "Cas semula untuk membuka kunci",
        "gengxin": "Caj semula pesanan menunggu pembayaran",
        "yibiaoti": "Rekod cas semula",
        "yaoqing": "Arahan cas semula",
        "yaoqingren": "Sila hubungi khidmat pelanggan untuk cas semula",
        "shijian": "Jumlah cas semula",
        "choujiangci": "Tambah nilai",
        "choujianggai": "Isi semula",
        "tuijianren": "pendaftaran percuma",
        "xiejie": "Kami sedang bekerja keras untuk mendapatkan pesanan, dan hasilnya akan dikeluarkan di bawah.",
        "jiriqi": "semua produk",
        "dianjifu": "Tarik balik semua",
        "tishi": {
            "1": "semua",
            "2": "membeku",
            "3": "Jika penyerahan tidak disahkan dalam beberapa minit, sistem akan membekukan jumlah pesanan."
        },
        "chongzhijin": "titik",
        "chongzhigai": "padam",
        "nindeyu": "Masa ketibaan : 5 minit",
        "mianchong": "baki aset yang ada",
        "mianchongci": "memuatkan",
        "chongzhili": {
            "title": "kemas kini berjaya",
            "jine": "Pergi untuk memuat naik",
            "shijian": "Pergi ambil pesanan",
            "zhauntai": "Pergi untuk menambah"
        },
        "yijiangli": "Hantar kod pengesahan",
        "yiqizhuan": "Batal",
        "jianglili": "Baki yang ada",
        "shezhi": "Baki yang ada",
        "mimashe": "perjanjian",
        "dangqianmishu": "bekerjasama",
        "xinmi": "nama",
        "shuxinmi": "Masukkan keadaan tamat masa selepas",
        "quemi": "komoditi",
        "shuquemi": "Laman utama pusat beli-belah",
        "dainyou": "kembali ke laman utama",
        "dianyoudi": "Saiz pasukan",
        "shudainyou": "Baki pasukan",
        "fukuanshe": "Status komisen pasukan",
        "bitedi": "Jumlah komisen pasukan",
        "shugukuan": "Jumlah cas semula pasukan",
        "jisheng": "Jumlah pengeluaran pasukan",
        "qiangou": "Komisen pesanan pasukan",
        "xiacixiaoshi": "Laporan pasukan",
        "yingjian": "Aliran pasukan",
        "zonggong": "Pengurusan pasukan",
        "maidian": "pasukan",
        "yingjiancheng": "Buka dalam penyemak imbas",
        "zhuanzhang": "Pembayaran dalam talian",
        "dianfeizong": "kawasan",
        "zhuanzhangti": "Berjaya disalin",
        "zhaunzhangfeiyong": "Salin pautan",
        "zuidifei": "klon",
        "tikuanjin": "langit",
        "zuidixian": "Tetapan avatar",
        "bijieshou": "avatar",
        "quezhi": "Jika anda menghadapi masalah dan memerlukan bantuan, sila hubungi perkhidmatan pelanggan dalam talian",
        "querenti": "Nama",
        "yiwen": "mendepositkan sejumlah wang",
        "tili": "Jumlah deposit tidak memenuhi keperluan sistem",
        "yaohaoyou": "deposit",
        "yaohuoci": "sejarah akses",
        "yihanwei": "jaminan rasmi",
        "gongxihuo": "Disediakan secara rasmi"
    },
    "into_two": {
        "yibiaoban": "Pengurusan kewangan yang kerap",
        "nihao": "Sudah tentu",
        "yue": "Kegagalan audit",
        "shebeigong": "peperiksaan lulus",
        "riqi": "Khidmat Pelanggan",
        "gaishu": "khidmat Pelanggan",
        "kaicaizong": "rangkaian",
        "xiaoshili": "Pengurusan kata laluan",
        "rili": "Pengguna yang dihormati, untuk memastikan keselamatan dana anda, sila ikat nama sebenar anda dan tetapkan kata laluan pengeluaran. Jika nama tidak sepadan dengan nama pembukaan akaun, pengeluaran tidak akan dapat dilakukan",
        "zhouli": "Titik perpuluhan mesti diisi",
        "yeli": "jam, sistem akan dinyahbeku secara automatik selepas tamat tempoh",
        "tuilian": "Leret ke kiri atau kanan untuk melihat lebih banyak lagi",
        "hezuo": "Telah dihantar",
        "fukuanxin": "selesai",
        "tianjiadi": "Dibatalkan",
        "gengxin": "Sila masukkan e-mel anda",
        "yibiaoti": "Sudah mempunyai akaun?",
        "yaoqing": "Sudah mempunyai akaun, muat turun sekarang",
        "yaoqingren": "tamat tempoh",
        "shijian": "lulus",
        "choujiangci": "Diketepikan",
        "choujianggai": "Mulakan jalan anda menuju kekayaan",
        "tuijianren": "Pemegang akaun",
        "xiejie": "Perjanjian pembukaan akaun",
        "jiriqi": "Nama akaun",
        "dianjifu": "Alamat pembukaan akaun",
        "tishi": {
            "1": "Bank pembukaan akaun",
            "2": "Bank deposit",
            "3": "Pendapatan hari ini"
        },
        "chongzhijin": "Pembayaran belum selesai",
        "chongzhigai": "Yang belum selesai",
        "nindeyu": "Semakan belum selesai",
        "mianchong": "Untuk dibayar",
        "mianchongci": "Menunggu resit",
        "chongzhili": {
            "title": "Untuk dibuka kuncinya",
            "jine": "Anda boleh terus menekan lama untuk mengenal pasti kod QR di WeChat",
            "shijian": "lupa kata laluan",
            "zhauntai": "Pengeluaran tunai cepat"
        },
        "yijiangli": "Jumlah cas semula",
        "yiqizhuan": "Jumlah pengeluaran",
        "jianglili": "Jumlah hasil",
        "shezhi": "Jumlah aset",
        "mimashe": "baki anda",
        "dangqianmishu": "Pesanan anda akan dibuat pada",
        "xinmi": "Pesanan anda telah dibekukan , sila tunggu dengan sabar",
        "shuxinmi": "Pesanan anda telah tamat tempoh dan tidak boleh diproses",
        "quemi": "maklumat identiti anda",
        "shuquemi": "Maklumat kad bank anda",
        "dainyou": "Adakah anda pasti mahu memadamkan alamat ini?",
        "dianyoudi": "Anda belum menambah maklumat kad bank lagi",
        "shudainyou": "Saya telah bersetuju dengan \"Perjanjian Perkhidmatan\"",
        "fukuanshe": "Saya telah menyelesaikan pembayaran",
        "bitedi": "Saya telah faham dan bersetuju",
        "shugukuan": "baki saya",
        "jisheng": "pasukan saya",
        "qiangou": "jumlah aset saya",
        "xiacixiaoshi": "nombor telefon bimbit saya",
        "yingjian": "Arahan saya",
        "zonggong": "Dompet saya",
        "maidian": "Kad debit saya",
        "yingjiancheng": "saya",
        "zhuanzhang": "Tangkapan skrin atau secara langsung",
        "dianfeizong": "Bank",
        "zhuanzhangti": "Semua barang",
        "zhaunzhangfeiyong": "semua jenis",
        "zuidifei": "Nombor telefon bimbit salah",
        "tikuanjin": "Nombor telefon mudah alih dimasukkan dengan salah",
        "zuidixian": "nombor telefon",
        "bijieshou": "Nombor telefon",
        "quezhi": "telefon bimbit",
        "querenti": "yuran pengendalian",
        "yiwen": "Merebut pesanan",
        "tili": "Order grab masa",
        "yaohaoyou": "Nombor pesanan",
        "yaohuoci": "Rekod merebut pesanan",
        "yihanwei": "Rekod",
        "gongxihuo": "Arahan merebut pesanan"
    },
    "into_s1": {
        "yibiaoban": "ambil pesanan",
        "nihao": "Kuantiti pesanan",
        "yue": "Rebat komisen untuk mengambil pesanan",
        "shebeigong": "poster promosi",
        "riqi": "Bilangan orang yang disyorkan",
        "gaishu": "Produk yang disyorkan",
        "kaicaizong": "mengesyorkan",
        "xiaoshili": "menyerahkan",
        "rili": "Penyerahan berjaya , sila tunggu dengan sabar untuk semakan",
        "zhouli": "Penyerahan berjaya , akan diubah hala tidak lama lagi",
        "yeli": "Hantar pesanan",
        "tuilian": "serahkan",
        "hezuo": "Bilangan pengeluaran",
        "fukuanxin": "Status pengeluaran",
        "tianjiadi": "Permohonan pengeluaran telah dikemukakan",
        "gengxin": "Rekod pengeluaran",
        "yibiaoti": "Kadar pengeluaran",
        "yaoqing": "Jumlah Pengeluaran",
        "yaoqingren": "Had pengeluaran",
        "shijian": "menarik diri",
        "choujiangci": "cari",
        "choujianggai": "kaedah pembayaran",
        "tuijianren": "Alamat cawangan",
        "xiejie": "penerima",
        "jiriqi": "Penerima bayaran",
        "dianjifu": "standard pendapatan",
        "tishi": {
            "1": "Jenis faedah",
            "2": "Rekod pendapatan",
            "3": "Nama penerima"
        },
        "chongzhijin": "Maklumat alamat penghantaran",
        "chongzhigai": "Pengubahsuaian alamat penghantaran",
        "nindeyu": "Suntingan alamat penghantaran",
        "mianchong": "Alamat penghantaran",
        "mianchongci": "Menerima maklumat identiti",
        "chongzhili": {
            "title": "Orang baru",
            "jine": "Kata laluan baharu",
            "shijian": "Nombor mudah alih baharu",
            "zhauntai": "masa"
        },
        "yijiangli": "Komisen pasukan semalam",
        "yiqizhuan": "Pendapatan semalam",
        "jianglili": "Tiada data",
        "shezhi": "Tiada rekod lagi",
        "mimashe": "Maklumat lanjut",
        "dangqianmishu": "Lagi",
        "xinmi": "Kad bank tidak terikat , pergi untuk mengikatnya",
        "shuxinmi": "Tiada kawasan yang dimasukkan, sila tetapkannya",
        "quemi": "Bank pembukaan akaun tidak dimasukkan, sila tetapkan",
        "shuquemi": "Alamat cawangan tidak dimasukkan, sila tetapkannya",
        "dainyou": "Tiada nombor telefon dimasukkan, sila tetapkan",
        "dianyoudi": "Tiada nombor telefon dimasukkan, sila tetapkan",
        "shudainyou": "Tiada nama sebenar dimasukkan, sila tetapkan",
        "fukuanshe": "Tiada alamat terperinci dimasukkan, sila tetapkannya",
        "bitedi": "Tiada nombor kad bank dimasukkan, sila tetapkan",
        "shugukuan": "tidak dimasukkan , sila tetapkannya",
        "jisheng": "Data ini disediakan oleh",
        "qiangou": "Yuran pengendalian akan ditolak untuk pengeluaran ini.",
        "xiacixiaoshi": "Memuatkan",
        "yingjian": "Boleh ambil order setiap hari",
        "zonggong": "Tiada kod QR , sila klik",
        "maidian": "tiada data",
        "yingjiancheng": "Tiada lagi kandungan",
        "zhuanzhang": "Tiada lagi data",
        "dianfeizong": "Tiada catatan",
        "zhuanzhangti": "Masa pendaftaran",
        "zhaunzhangfeiyong": "mendaftar",
        "zuidifei": "Nota: Oleh kerana jumlah maklumat cas semula yang banyak, pastikan anda menyemak nombor kad akaun dengan teliti sebelum mengecas semula Platform ini dari semasa ke semasa Jika anda mempunyai sebarang pertanyaan, sila klik perkhidmatan pelanggan dalam talian",
        "tikuanjin": "Pusat aktiviti",
        "zuidixian": "Bilangan orang yang aktif",
        "bijieshou": "Alamat penghantaran baharu",
        "quezhi": "Petua yang baik",
        "querenti": "negeri",
        "yiwen": "Caj semula pengguna",
        "tili": "Nama pengguna tidak boleh kosong",
        "yaohaoyou": "Ralat input nama pengguna , memerlukan 2-12 huruf atau nombor",
        "yaohuoci": "Pengguna mengambil pesanan",
        "yihanwei": "Pengeluaran pengguna",
        "gongxihuo": "nombor telefon"
    },
    "into_f": {
        "yibiaoban": "Kata laluan log masuk",
        "nihao": "Log masuk",
        "yue": "Terus di bawah",
        "shebeigong": "Terus di bawah",
        "riqi": "nama sebenar",
        "gaishu": "Sahkan pengubahsuaian",
        "kaicaizong": "Sahkan pengikatan kad",
        "xiaoshili": "pasti",
        "rili": "Sahkan cas semula",
        "zhouli": "Adakah anda mengesahkan pembatalan ? Pembatalan akan mengakibatkan jumlah tersebut dibekukan.",
        "yeli": "Sahkan Kata Laluan",
        "tuilian": "Sahkan untuk mengeluarkan jumlah ini ke baki? Tiada faedah akan dikira pada pengeluaran yang tidak wajar! , dan tolak",
        "hezuo": "Sahkan untuk keluar?",
        "fukuanxin": "Kembali ke halaman saya dalam beberapa saat",
        "tianjiadi": "Kedua",
        "gengxin": "Tarik balik serta merta",
        "yibiaoti": "beli sekarang",
        "yaoqing": "naik taraf segera",
        "yaoqingren": "Sediakan sekarang",
        "shijian": "Menunggu pengesahan dari pembeli",
        "choujiangci": "Menunggu pengesahan pembeli",
        "choujianggai": "Menunggu respons sistem pedagang",
        "tuijianren": "penapis",
        "xiejie": "pengenalan",
        "jiriqi": "pemberitahuan sistem",
        "dianjifu": "Sistem ini berdasarkan teknologi LBS dan secara automatik memadankan produk melalui awan.",
        "tishi": {
            "1": "Akaun sistem",
            "2": "Pendapatan terkumpul",
            "3": "Caj semula dalam talian"
        },
        "chongzhijin": "Caj semula luar talian",
        "chongzhigai": "Ikat nombor telefon bimbit",
        "nindeyu": "Ikat kad bank",
        "mianchong": "perangkaan",
        "mianchongci": "Edit alamat penghantaran",
        "chongzhili": {
            "title": "Edit kad debit",
            "jine": "edit",
            "shijian": "Rangkaian tidak stabil , sila cuba lagi di tempat yang mempunyai isyarat yang lebih baik",
            "zhauntai": "Rangkaian tidak stabil , sila cuba lagi di tempat yang mempunyai isyarat yang lebih baik"
        },
        "yijiangli": "Nombor telefon",
        "yiqizhuan": "Pergi ambil pesanan",
        "jianglili": "automatik",
        "shezhi": "Pengiraan automatik",
        "mimashe": "Pusat beli-belah yang dikendalikan sendiri",
        "dangqianmishu": "kepada",
        "xinmi": "Dapatkan kod pengesahan",
        "shuxinmi": "peraturan",
        "quemi": "Buka kunci",
        "shuquemi": "nombor pesanan",
        "dainyou": "Pesanan telah dibekukan dan masa tidak beku adalah",
        "dianyoudi": "Pesanan telah tamat masa",
        "shudainyou": "Jumlah keseluruhan pesanan",
        "fukuanshe": "Jumlah pesanan",
        "bitedi": "Pesanan sedang dihantar",
        "shugukuan": "Pesanan berjaya dihantar",
        "jisheng": "Maklumat-maklumat Pesanan",
        "qiangou": "Pesanan",
        "xiacixiaoshi": "Ingat kata laluan",
        "yingjian": "Tetapkan sebagai alamat biasa",
        "zonggong": "Tetapkan sebagai lalai",
        "maidian": "Tetapkan avatar",
        "yingjiancheng": "Butiran",
        "zhuanzhang": "Alamat",
        "dianfeizong": "Sila muat naik baucar pembayaran",
        "zhuanzhangti": "Sila muat naik baucar caj semula",
        "zhaunzhangfeiyong": "Sila semak maklumat pembayaran dengan teliti",
        "zuidifei": "sila bayar",
        "tikuanjin": "Sila tukar nama anda",
        "zuidixian": "Sila pastikan anda menyimpan amaun pemindahan kepada titik perpuluhan untuk mengelak daripada menjejaskan masa cas semula.",
        "bijieshou": "Sila pindahkan dan caj semula ke akaun berikut",
        "quezhi": "Sila rujuk perkhidmatan pelanggan dalam talian selepas melengkapkan caj semula",
        "querenti": "Sila isikan nama cas semula",
        "yiwen": "Sila isikan nombor telefon bimbit cas semula",
        "tili": "Sila isikan jumlah caj semula",
        "yaohaoyou": "Sila isikan nama anda",
        "yaohuoci": "sila isi nombor telefon bimbit",
        "yihanwei": "Sila isikan nombor telefon bimbit yang betul",
        "gongxihuo": "Sila isikan alamat terperinci"
    },
    "into_s": {
        "yibiaoban": "Sila isikan alamat penghantaran yang terperinci",
        "nihao": "Sila ingat kata laluan anda . Jika anda terlupa kata laluan anda, sila hubungi perkhidmatan pelanggan.",
        "yue": "Sila tanya perkhidmatan pelanggan dalam talian (platform menukar akaun dari semasa ke semasa)",
        "shebeigong": "Sila masukkan kata laluan transaksi",
        "riqi": "Sila masukkan jumlah caj semula",
        "gaishu": "Sila masukkan kata laluan asal",
        "kaicaizong": "Sila masukkan kata laluan",
        "xiaoshili": "Sila masukkan nama pemegang akaun",
        "rili": "Sila masukkan nombor telefon mudah alih pemegang akaun",
        "zhouli": "Sila masukkan alamat bank pembukaan akaun",
        "yeli": "Sila masukkan bank pembukaan akaun",
        "tuilian": "Sila masukkan bank tempat akaun dibuka",
        "hezuo": "Sila masukkan kata laluan baharu anda",
        "fukuanxin": "Sila masukkan nombor telefon",
        "tianjiadi": "Sila masukkan kod pengesahan telefon mudah alih",
        "gengxin": "Sila masukkan kod rujukan",
        "yibiaoti": "Sila masukkan jumlah pengeluaran",
        "yaoqing": "Sila masukkan nama penerima",
        "yaoqingren": "Sila masukkan kata laluan baharu",
        "shijian": "Sila masukkan nombor telefon bimbit atau alamat e-mel anda",
        "choujiangci": "sila masukkan nama pengguna",
        "choujianggai": "Sila masukkan kata laluan log masuk anda",
        "tuijianren": "Sila masukkan kod pengesahan SMS",
        "xiejie": "Sila masukkan akaun /kata laluan anda",
        "jiriqi": "Sila masukkan kata laluan dana",
        "dianjifu": "Sila masukkan amaun pindahan",
        "tishi": {
            "1": "Sila masukkan kod jemputan",
            "2": "Sila masukkan nombor kad bank",
            "3": "sila masukkan kod pengesahan"
        },
        "chongzhijin": "Sila pilih saluran pembayaran",
        "chongzhigai": "Sila pilih saluran pembayaran",
        "nindeyu": "Sila pilih alamat penghantaran",
        "mianchong": "Sila pilih tahap yang anda ingin tingkatkan",
        "mianchongci": "baki akaun",
        "chongzhili": {
            "title": "Amaun beku akaun",
            "jine": "Butiran akaun",
            "shijian": "Jumlah akaun",
            "zhauntai": "Hasil daripada pembelian"
        },
        "yijiangli": "Beli tanpa memasukkan nama sebenar anda, sila sediakan",
        "yiqizhuan": "Apabila membeli produk kewangan , keuntungan tidak akan dikira untuk pembelian berniat jahat dan yuran pengendalian akan dikenakan.",
        "jianglili": "Beli",
        "shezhi": "Kata laluan dana",
        "mimashe": "Mengubah hala",
        "dangqianmishu": "Untuk memindahkan wang, sila salin mesej dan pergi ke perbankan dalam talian atau Alipay untuk menyelesaikan pemindahan dan caj semula.",
        "xinmi": "Masukkan jumlah caj semula",
        "shuxinmi": "Masukkan nama",
        "quemi": "Masukkan jumlah deposit",
        "shuquemi": "masukkan nombor telefon bimbit",
        "dainyou": "Masukkan kata laluan dana",
        "dianyoudi": "Pulang",
        "shudainyou": "kembali",
        "fukuanshe": "Tiada alamat penuaian telah ditambahkan lagi",
        "bitedi": "Tiada kad bank ditambahkan lagi",
        "shugukuan": "Pergi ke kedai dan lihat",
        "jisheng": "Hos jauh memperuntukkan",
        "qiangou": "log keluar",
        "xiacixiaoshi": "Pilih kaedah cas semula",
        "yingjian": "Pilih kaedah pengeluaran",
        "zonggong": "Pilih kuantiti",
        "maidian": "Pilih produk kewangan",
        "yingjiancheng": "menjemput kawan-kawan",
        "zhuanzhang": "Sertai untuk mendapatkan lebih banyak faedah",
        "dianfeizong": "Kod Jemputan",
        "zhuanzhangti": "Pautan jemputan : klik untuk menyalin",
        "zhaunzhangfeiyong": "Sila semak maklumat pembayaran dengan teliti",
        "zuidifei": "Pengeluaran tunai kad kewangan",
        "tikuanjin": "Akaun kad debit",
        "zuidixian": "kad bank",
        "bijieshou": "nama bank",
        "quezhi": "soalan",
        "querenti": "Jika anda memerlukan bantuan, anda boleh menghubungi khidmat pelanggan untuk mengecas semula secara manual.",
        "yiwen": "Perlu bayar balik",
        "tili": "Anggaran pendapatan",
        "yaohaoyou": "Pulangan yang dijangkakan",
        "yaohuoci": "Bilangan orang yang membuat deposit pertama",
        "yihanwei": "muka depan",
        "gongxihuo": "Isi semula sekarang"
    },
    "into_se": {
        "yibiaoban": "Kod pengesahan",
        "nihao": "lalai",
        "yue": "Sila ambil tangkapan skrin APP secara manual dan simpannya secara setempat untuk mengimbas kod QR.",
        "shebeigong": "Sila gunakan APP secara manual",
        "riqi": "Rumah",
        "gaishu": "Kata LaluanLog",
        "kaicaizong": "Belum diserahkan lagi",
        "xiaoshili": "pendaftaran berjaya",
        "rili": "Boleh dinaik taraf",
        "zhouli": "Tidak dapat menaik taraf",
        "yeli": "Tidak dapat menaik taraf jika syarat naik taraf tidak dipenuhi",
        "tuilian": "Anda telah mencapai kriteria peningkatan dan telah menyelesaikan peningkatan",
        "hezuo": "pemberitahuan sistem",
        "fukuanxin": "Baki pengguna tidak mencukupi",
        "tianjiadi": "Tidak cukup pengguna jemputan",
        "gengxin": "Syarat naik taraf tidak dipenuhi",
        "yibiaoti": "Baki akaun yang diperlukan adalah lebih besar daripada",
        "yaoqing": "jemput",
        "yaoqingren": "untuk membuka kunci",
        "shijian": "alamat dompet",
        "choujiangci": "Imbasan dompet tersedia untuk pemindahan",
        "choujianggai": "Komisen pasukan hari ini",
        "tuijianren": "Muat turun APP",
        "xiejie": "Bonus cas semula",
        "jiriqi": "Sila masukkan alamat TRC20",
        "dianjifu": "Sila masukkan alamat ERC20",
        "tishi": {
            "1": "tentang kita",
            "2": "ejen",
            "3": "peraturan"
        },
        "chongzhijin": "memperkenalkan",
        "chongzhigai": "Kelayakan",
        "nindeyu": "Terkejut apabila membuka kotak hadiah",
        "mianchong": "Buat duit segera",
        "mianchongci": "Kata laluan lama",
        "chongzhili": {
            "title": "Sila masukkan kata laluan lama",
            "jine": "Sila masukkan kata laluan sekali lagi",
            "shijian": "kata laluan telah dikemas kini",
            "zhauntai": "Gagal menukar kata laluan"
        },
        "yijiangli": "Sila tandai kotak untuk bersetuju dengan perjanjian",
        "yiqizhuan": "Anda telah mencapai kriteria peningkatan dan telah ditingkatkan secara automatik",
        "jianglili": "Diturunkan taraf kerana perubahan baki",
        "shezhi": "pemberitahuan sistem",
        "mimashe": "pesanan dagangan",
        "dangqianmishu": "Pembayaran telah dipaksa oleh sistem Jika anda mempunyai sebarang pertanyaan, sila hubungi perkhidmatan pelanggan",
        "xinmi": "Hidupkan pengambilan pesanan automatik",
        "shuxinmi": "Matikan pengambilan pesanan automatik",
        "quemi": "Nama pengguna pendua",
        "shuquemi": "Diturunkan taraf kerana perubahan baki",
        "dainyou": "Anda telah mencapai kriteria peningkatan dan telah ditingkatkan secara automatik",
        "dianyoudi": "telefon",
        "shudainyou": "tentang kita",
        "fukuanshe": "Lihat sekarang",
        "bitedi": "platform",
        "shugukuan": "pengumuman",
        "jisheng": "Ajak rakan-rakan untuk mendapatkan wang tunai",
        "chongxindenglu": "Sila log masuk semula",
        "pingtaijianjie": "Pengenalan platform",
        "pingtaijianjie1": "Peraturan merebut pesanan",
        "pingtaijianjie2": "Kerjasama agensi",
        "pingtaijianjie3": "Kelayakan syarikat"
    },
    "qing_sd": "Sila tunggu",
    "loading1": "proksi dalam talian",
    "loading2": "meminta pesanan",
    "loading3": "Merebut pesanan",
    "goods": {
        "0": "kaca hijau",
        "1": "Produk penjagaan kulit eksklusif",
        "2": "Cawan plastik gred makanan",
        "3": "minyak wangi klasik",
        "4": "biji kopi import",
        "5": "Beruang gaya Disney"
    },
    "tab_name": {
        "0": "muka depan",
        "1": "Rekod pesanan",
        "2": "Membuat pesanan",
        "3": "khidmat Pelanggan",
        "4": "saya"
    },
    "pingjia": "menilai",
    "login_t1": "One-stop shop for shopping around the world and earning rebates",
    "zhangh": "Sila masukkan nombor telefon bimbit",
    "email": "E-mel",
    "use_app": "Gunakan Apl",
    "index_t1": "Diskaun 30% Tambahan + Pulangan Tunai 10% + Penghantaran Percuma untuk Pembelian Apl Pertama Anda",
    "qianbao": "dompet",
    "huoqu_yj": "Dapat komisen",
    "zhangh_ye": "Baki akaun",
    "zhangh_je": "baki akaun",
    "huoq_yj": "Dapat komisen",
    "dingd_s": "kuantiti pesanan",
    "caoz_bz": "Langkah-langkah",
    "caoz_t1": "1. Klik butang Mulakan Tugas dan ikut arahan untuk menyelesaikan tugasan.",
    "caoz_t2": "2. Selepas menyelesaikan tugas, anda boleh menyelesaikan komisen kepada baki",
    "kefu_t1": "Jika anda mempunyai sebarang pertanyaan atau memerlukan bantuan,",
    "kefu_t2": "Sila hubungi perkhidmatan pelanggan dalam talian untuk menyelesaikannya untuk anda",
    "kefu_t3": "Perkhidmatan pelanggan berdedikasi anda",
    "changj_wtjd": "Soalan Lazim",
    "changj_wt": {
        "0": {
            "name": "Bagaimana untuk mengecas semula dan apakah kaedah pembayaran yang tersedia ?",
            "value": "Sistem ini terbuka kepada berbilang negara, dan kaedah pembayaran antarabangsa yang kami sediakan termasuk: USDT (ERC20). Pada masa yang sama, kami juga menyokong mata wang negara dari negara yang berbeza."
        },
        "1": {
            "name": "Bagaimanakah saya boleh melabur dan memperoleh pendapatan ?",
            "value": "Anda boleh mengambil bahagian dalam transaksi komoditi dalam sistem dan memperoleh pendapatan transaksi yang stabil setiap hari. Semua pendapatan boleh dikeluarkan ke kad bank anda."
        },
        "2": {
            "name": "Bagaimana untuk mendaftar sebagai ahli ?",
            "value": "Sistem jemputan digunakan untuk mendaftar ahli baru Bagi memastikan pendapatan ahli yang berdaftar dan mengelakkan pendaftaran berlebihan daripada mengurangkan pendapatan, ahli baharu hanya boleh mendaftar di bawah jemputan ahli sedia ada."
        },
        "3": {
            "name": "Adakah terdapat had pada jumlah pembelian ?",
            "value": "Ya, untuk memberi lebih ramai ahli peluang memperoleh keuntungan, setiap akaun dalam sistem mempunyai had pembelian minimum."
        }
    },
    "yonghu_m": "nama pengguna",
    "shoukuan_zh": "Akaun belum terima",
    "youxiang": "Mel",
    "zhanghao": "akaun",
    "xiugai_mima": "tukar kata laluan",
    "xuanze_yy": "Pilih bahasa",
	queren:'mengesahkan',
	bangka:'Sila ikat akaun pembayaran',
	xingy_d:'Tahniah, anda telah mendapat tempahan bertuah'
}